/**
 * PDP — comportamiento (Mar Amoli)
 *
 * Extraído de los <script> inline de sections/ma-product.liquid: eran 32 KB
 * que viajaban dentro del HTML en CADA carga de producto y se re-parseaban en
 * cada navegación. Como asset se cachean una vez y se reutilizan entre PDPs.
 *
 * Se movieron solo los bloques SIN Liquid. Los que interpolan datos del
 * producto (JSON-LD, el JSON de ingredientes) siguen inline a propósito.
 *
 * Carga con `defer`: corre antes de DOMContentLoaded y el DOM ya está
 * parseado, que es lo que asumían estos bloques al vivir al final del body.
 */

/* ── Bloque 1 de 4 ─────────────────────────────────────────── */
// Purge de cualquier widget de suscripción de tercero (Appstle u otra app)
  // dentro del PDP. Detectamos por SEMÁNTICA, no por nombre de clase:
  // cualquier input[name="selling_plan"] que NO esté dentro del wrapper
  // .ma-pdp__purchase del theme es por definición un widget duplicado y
  // se elimina junto con su contenedor visual. El backend de la app sigue
  // funcional porque solo tocamos UI del PDP.
  (function () {
    "use strict";
    var ROOT = document.querySelector("section.ma-pdp");
    if (!ROOT) return;

    function findWidgetWrapper(el) {
      // Sube hasta encontrar el contenedor lógico del widget — uno cuyo
      // padre es un nodo "estructural" del theme (form, buy-row, info col).
      var node = el;
      var safe = [
        "ma-pdp__form",
        "ma-pdp__buy-row",
        "ma-pdp__info",
        "ma-pdp__col",
        "ma-pdp__left",
        "ma-pdp",
      ];
      while (node && node.parentElement && node.parentElement !== document.body) {
        var p = node.parentElement;
        var cls = (p.className && typeof p.className === "string") ? p.className : "";
        var isStructural = safe.some(function (c) { return cls.indexOf(c) !== -1; }) ||
                           p.tagName === "MA-PRODUCT-FORM" ||
                           p.tagName === "FORM";
        if (isStructural) break;
        node = p;
      }
      return node;
    }

    function purge() {
      // 1) Cualquier elemento con "appstle" en class/id/data
      var byName = ROOT.querySelectorAll(
        '[class*="appstle" i], [id*="appstle" i], [data-appstle], appstle-subscription-app, appstle-subscription-policy'
      );
      byName.forEach(function (n) { n.remove(); });

      // 2) Inputs de selling_plan que NO sean nuestros — son del widget de la app
      var radios = ROOT.querySelectorAll('input[name="selling_plan"], input[name*="selling-plan" i], input[data-selling-plan]');
      radios.forEach(function (r) {
        if (r.closest(".ma-pdp__purchase")) return; // nuestro
        var wrapper = findWidgetWrapper(r);
        if (wrapper && wrapper !== ROOT) wrapper.remove();
      });

      // 3) Texto característico del widget de Appstle ("AHORRE", "Suscripción y ahorra", etc.)
      //    que pueda quedar fuera de inputs (e.g. badges sueltos)
      var TEXT_SIGNATURES = [/\bAHORRE\b/i, /Subscribe\s*&?\s*save/i];
      var candidates = ROOT.querySelectorAll(".ma-pdp__form *, .ma-pdp__info > *");
      candidates.forEach(function (el) {
        if (el.closest(".ma-pdp__purchase")) return;
        if (el.children && el.children.length > 0) return; // solo hojas
        var txt = (el.textContent || "").trim();
        if (!txt) return;
        if (TEXT_SIGNATURES.some(function (rx) { return rx.test(txt); })) {
          var wrapper = findWidgetWrapper(el);
          if (wrapper && wrapper !== ROOT) wrapper.remove();
        }
      });
    }

    purge();
    // Re-purgar cuando el DOM cambia (apps inyectan async). Debounced a un
    // purge por frame — antes corría purge() en CADA mutación, y las apps
    // (AirReviews, etc.) inyectan en ráfaga → thrashing del main-thread en la
    // página más visitada. Además desconectamos a los 8s (para entonces las
    // apps ya inyectaron; los setTimeout de refuerzo cubren inyecciones tardías).
    var purgeScheduled = false;
    function schedulePurge() {
      if (purgeScheduled) return;
      purgeScheduled = true;
      requestAnimationFrame(function () { purgeScheduled = false; purge(); });
    }
    var obs = new MutationObserver(schedulePurge);
    obs.observe(ROOT, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 8000);
    // Refuerzo: re-purgar en hitos de carga
    window.addEventListener("load", purge);
    document.addEventListener("DOMContentLoaded", purge);
    setTimeout(purge, 1000);
    setTimeout(purge, 3000);
    setTimeout(purge, 6000);
  })();

/* ── Bloque 2 de 4 ─────────────────────────────────────────── */
// Rating de arriba (mhead) clicable → baja a las reseñas con scroll suave.
  (function () {
    const reviews = document.getElementById('reviews');
    if (!reviews) return;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-scroll-reviews]');
      if (!trigger) return;
      e.preventDefault();
      reviews.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
    });
  }());

  // Gallery thumbs
  (function () {
    const thumbs = document.querySelectorAll('.ma-pdp__thumb');
    const figures = document.querySelectorAll('.ma-pdp__main-figure');
    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => {
        thumbs.forEach((x) => { x.classList.remove('active'); x.setAttribute('aria-selected', 'false'); });
        figures.forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        t.setAttribute('aria-selected', 'true');
        const f = figures[i];
        if (f) f.classList.add('active');
      });
    });
  }());

  // Descripción como PRIMERA pestaña (solo móvil). Mueve el texto de
  // .ma-pdp__lead a un tab "Descripción" al frente y oculta el lead
  // standalone. Corre ANTES del IIFE de tabs para que éste lo cablee.
  // Si no hay tabs o no hay descripción, no hace nada (el lead se queda).
  (function () {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    const wrap = document.querySelector('[data-pdp-tabs]');
    const lead = document.querySelector('.ma-pdp__lead');
    if (!wrap || !lead) return;
    const html = lead.innerHTML.trim();
    if (!html) return;
    const bar = wrap.querySelector('.ma-pdp__tabs-bar');
    if (!bar) return;

    const btn = document.createElement('button');
    btn.className = 'ma-pdp__tab active';
    btn.type = 'button';
    btn.setAttribute('role', 'tab');
    btn.id = 'ma-pdp-tab-desc';
    btn.setAttribute('aria-controls', 'ma-pdp-panel-desc');
    btn.setAttribute('aria-selected', 'true');
    btn.setAttribute('tabindex', '0');
    btn.dataset.tab = 'desc';
    btn.textContent = 'Descripción';

    const panel = document.createElement('div');
    panel.className = 'ma-pdp__tab-panel active';
    panel.id = 'ma-pdp-panel-desc';
    panel.dataset.panel = 'desc';
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', 'ma-pdp-tab-desc');
    panel.setAttribute('tabindex', '0');
    panel.innerHTML = html;

    // Desactivar la pestaña + panel activos actuales
    bar.querySelectorAll('.ma-pdp__tab.active').forEach((t) => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });
    wrap.querySelectorAll('.ma-pdp__tab-panel.active').forEach((p) => p.classList.remove('active'));

    bar.insertBefore(btn, bar.firstChild);
    wrap.insertBefore(panel, bar.nextSibling);

    lead.setAttribute('hidden', '');
  }());

  // Tabs — sigue ARIA APG tabs pattern (arrow keys, Home/End, roving tabindex).
  (function () {
    const wrap = document.querySelector('[data-pdp-tabs]');
    if (!wrap) return;
    const tabs = Array.from(wrap.querySelectorAll('.ma-pdp__tab'));
    const panels = wrap.querySelectorAll('.ma-pdp__tab-panel');
    function activate(tab, focus) {
      const id = tab.dataset.tab;
      tabs.forEach((x) => {
        x.classList.remove('active');
        x.setAttribute('aria-selected', 'false');
        x.setAttribute('tabindex', '-1');
      });
      panels.forEach((x) => x.classList.remove('active'));
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      const panel = wrap.querySelector(`[data-panel="${id}"]`);
      if (panel) panel.classList.add('active');
      if (focus) tab.focus();
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (e) => {
        let target = null;
        if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') target = tabs[0];
        else if (e.key === 'End') target = tabs[tabs.length - 1];
        if (target) { e.preventDefault(); activate(target, true); }
      });
    });
  }());

  // Qty stepper — dispatch input event so the WC's _updateLineTotal fires
  (function () {
    const input = document.querySelector('[data-qty-input]');
    if (!input) return;
    const dec = document.querySelector('[data-qty-decrement]');
    const inc = document.querySelector('[data-qty-increment]');
    function setQty(n) {
      input.value = Math.max(1, n);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (dec) dec.addEventListener('click', () => setQty(parseInt(input.value, 10) - 1));
    if (inc) inc.addEventListener('click', () => setQty(parseInt(input.value, 10) + 1));
  }());

  // Tipo activo siempre a la vista: centra el swatch actual en el carrusel
  // al cargar (sin mover la página verticalmente). Así el usuario ve cuál
  // es el tipo elegido y puede picar otro.
  (function () {
    const grid = document.querySelector(".ma-pdp__related-grid");
    if (!grid) return;
    const active = grid.querySelector(".ma-pdp__related-swatch.active");
    if (!active) return;
    requestAnimationFrame(function () {
      if (grid.scrollWidth <= grid.clientWidth) return; // no scroll → nada
      const gridRect = grid.getBoundingClientRect();
      const aRect = active.getBoundingClientRect();
      const delta = (aRect.left - gridRect.left) - (grid.clientWidth - aRect.width) / 2;
      grid.scrollLeft = Math.max(0, grid.scrollLeft + delta);
    });
  }());

  // Variantes-as-products: hover preview using mouseenter on each swatch +
  // mouseleave on the whole wrap (so leaving any swatch into empty grid
  // space, or sliding off the wrap entirely, restores the original).
  (function () {
    const wrap = document.querySelector(".ma-pdp__related");
    if (!wrap) return;
    const nameEl = wrap.querySelector("[data-variant-name]");
    const firstFig = document.querySelector(".ma-pdp__main-figure");
    if (!nameEl || !firstFig) return;
    const firstImg = firstFig.querySelector("img");
    if (!firstImg) return;

    const originalName = wrap.getAttribute("data-variant-original-name") || nameEl.textContent;
    const originalSrc = firstImg.getAttribute("src");
    const originalSrcset = firstImg.getAttribute("srcset") || "";
    const originalSizes = firstImg.getAttribute("sizes") || "";
    const originalImage = wrap.getAttribute("data-variant-original-image") || originalSrc;

    function showImage(src) {
      if (!src) return;
      firstImg.removeAttribute("srcset");
      firstImg.removeAttribute("sizes");
      firstImg.src = src;
      document.querySelectorAll(".ma-pdp__main-figure").forEach(function (f, i) {
        f.classList.toggle("active", i === 0);
      });
    }
    function restore() {
      nameEl.textContent = originalName;
      firstImg.src = originalSrc;
      if (originalSrcset) firstImg.setAttribute("srcset", originalSrcset);
      if (originalSizes) firstImg.setAttribute("sizes", originalSizes);
      document.querySelectorAll(".ma-pdp__main-figure").forEach(function (f, i) {
        f.classList.toggle("active", i === 0);
      });
      wrap.querySelectorAll(".ma-pdp__related-swatch").forEach(function (s) {
        s.classList.remove("is-preview");
      });
    }

    wrap.querySelectorAll(".ma-pdp__related-swatch").forEach(function (sw) {
      sw.addEventListener("mouseenter", function () {
        const name = sw.getAttribute("data-variant-target-name");
        const img  = sw.getAttribute("data-variant-target-image");
        if (name) nameEl.textContent = name;
        if (img)  showImage(img);
        wrap.querySelectorAll(".ma-pdp__related-swatch").forEach(function (s) {
          s.classList.remove("is-preview");
        });
        if (!sw.classList.contains("active")) sw.classList.add("is-preview");
      });
    });

    wrap.addEventListener("mouseleave", restore);
  }());

  // Promise modals — robust open/close: Esc, click-outside-panel, X button
  // + focus trap (Tab cycles dentro del modal) + restore al opener
  (function () {
    const FOCUSABLE = 'button:not([disabled]),[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    let lastFocus = null;

    function getFocusables(modal) {
      return Array.from(modal.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function openModal(id) {
      const modal = document.getElementById(id);
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.removeAttribute("hidden");
      document.documentElement.style.overflow = "hidden";
      const focusable = modal.querySelector(".ma-pdp__modal-close");
      if (focusable) focusable.focus();
    }
    function closeAll() {
      const opened = document.querySelectorAll(".ma-pdp__modal:not([hidden])");
      opened.forEach((m) => m.setAttribute("hidden", ""));
      document.documentElement.style.overflow = "";
      // Restaurar focus al elemento que abrió el modal
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
      lastFocus = null;
    }

    document.addEventListener("click", function (e) {
      const opener = e.target.closest("[data-ma-modal-open]");
      if (opener) {
        e.preventDefault();
        openModal(opener.getAttribute("data-ma-modal-open"));
        return;
      }
      if (e.target.closest("[data-ma-modal-close]")) {
        closeAll();
        return;
      }
      // Click anywhere on the modal backdrop (outside the panel) closes
      const openModalEl = e.target.closest(".ma-pdp__modal");
      if (openModalEl && !openModalEl.hasAttribute("hidden") && !e.target.closest(".ma-pdp__modal-panel")) {
        closeAll();
      }
    });

    document.addEventListener("keydown", function (e) {
      const anyOpen = document.querySelector(".ma-pdp__modal:not([hidden])");
      if (!anyOpen) return;
      if (e.key === "Escape" || e.key === "Esc") {
        closeAll();
        return;
      }
      // Focus trap dentro del modal abierto
      if (e.key === "Tab") {
        const focusables = getFocusables(anyOpen);
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }());

  // Sticky mobile ATC bar — siempre presente en móvil (Glass Touch).
  // Refleja el form principal: precio unitario, stepper de cantidad y
  // total en vivo (qty × precio). El botón dispara el ATC principal.
  (function () {
    const sticky = document.querySelector('[data-pdp-sticky]');
    const mainAtc = document.querySelector('.ma-pdp__atc');
    if (!sticky || !mainAtc) return;

    const stickyAtc   = sticky.querySelector('[data-pdp-sticky-atc]');
    const stickyQty   = sticky.querySelector('[data-pdp-sticky-qty]');
    const stickyTotal = sticky.querySelector('[data-pdp-sticky-total]');
    const stickyDec   = sticky.querySelector('[data-pdp-sticky-dec]');
    const stickyInc   = sticky.querySelector('[data-pdp-sticky-inc]');
    const mainQty     = document.querySelector('[data-qty-input]');
    const isMobile    = window.matchMedia('(max-width: 768px)');

    // El sticky solo compite por bottom:0 con el bottom-nav en móvil.
    // Como es permanente en el PDP, ocultamos el bottom-nav ahí (el CTA de
    // conversión manda). En desktop el sticky es display:none, así que no
    // marcamos la clase para no esconder nada.
    function applyMode() {
      if (isMobile.matches) {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ma-has-sticky-atc');
      } else {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ma-has-sticky-atc');
      }
    }
    applyMode();
    if (isMobile.addEventListener) isMobile.addEventListener('change', applyMode);
    window.addEventListener('pagehide', () => {
      document.body.classList.remove('ma-has-sticky-atc');
    });

    // Espejo de valores del form principal → sticky. La cantidad va en el
    // stepper Y dentro del botón ("Agregar N · $total"). El total se RE-CREA
    // en cada cambio (_renderATC hace replaceChildren), lo releemos del ATC.
    const syncQty = () => {
      if (!mainQty) return;
      if (stickyQty) stickyQty.textContent = mainQty.value;
    };
    const syncTotal = () => {
      if (!stickyTotal) return;
      const t = mainAtc.querySelector('[data-pdp-line-total]');
      if (t) stickyTotal.textContent = t.textContent;
    };

    new MutationObserver(syncTotal).observe(mainAtc, { childList: true, characterData: true, subtree: true });
    if (mainQty)   mainQty.addEventListener('input', syncQty);
    syncQty(); syncTotal();

    // Stepper del sticky → maneja el input principal (que recalcula total)
    function setMainQty(n) {
      if (!mainQty) return;
      mainQty.value = Math.max(1, n | 0);
      mainQty.dispatchEvent(new Event('input',  { bubbles: true }));
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncQty();
    }
    if (stickyDec) stickyDec.addEventListener('click', () => setMainQty(parseInt(mainQty.value, 10) - 1));
    if (stickyInc) stickyInc.addEventListener('click', () => setMainQty(parseInt(mainQty.value, 10) + 1));

    // El botón del sticky dispara el ATC principal (ya cableado al AJAX add)
    if (stickyAtc) stickyAtc.addEventListener('click', () => mainAtc.click());
  }());

  // Galería móvil: puntitos de paginación siguen el scroll del carrusel.
  // (En desktop .ma-pdp__main-media no hace scroll y los dots van ocultos.)
  (function () {
    const media = document.querySelector('.ma-pdp__main-media');
    const dots = Array.prototype.slice.call(document.querySelectorAll('.ma-pdp__dot'));
    if (!media || dots.length < 2) return;
    let raf = null;
    function update() {
      raf = null;
      const w = media.clientWidth;
      if (!w) return;
      const idx = Math.min(dots.length - 1, Math.round(media.scrollLeft / w));
      dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    }
    media.addEventListener('scroll', () => {
      if (!raf) raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
  }());

  // Delivery countdown. Los modales de info y pickup son manejados por el
  // handler global de .ma-pdp__modal (data-ma-modal-open / data-ma-modal-close).
  (function () {
    const line1 = document.getElementById("maDeliveryLine1");
    const pickupText = document.getElementById("maPickupText");
    if (!line1 || !pickupText) return;

    const MONTERREY_CENTER = { lat: 25.6866, lng: -100.3161 };
    const MTY_RADIUS_KM = 35;
    const GEO_KEY = "maGeo";
    const GEO_TTL_MS = 1000 * 60 * 60 * 24 * 14;

    const isBusinessDay = (d) => { const day = d.getDay(); return day !== 0 && day !== 6; };
    const nextBusinessDay = (d) => {
      const x = new Date(d); x.setHours(0,0,0,0);
      while (!isBusinessDay(x)) x.setDate(x.getDate() + 1);
      return x;
    };
    const addBusinessDays = (d, n) => {
      const x = new Date(d); x.setHours(0,0,0,0);
      let added = 0;
      while (added < n) { x.setDate(x.getDate() + 1); if (isBusinessDay(x)) added++; }
      return x;
    };
    const pad2 = (n) => String(n).padStart(2, "0");
    const formatDateEs = (d) => {
      const weekday = new Intl.DateTimeFormat("es-MX", { weekday: "long" }).format(d);
      const month = new Intl.DateTimeFormat("es-MX", { month: "long" }).format(d);
      return `${weekday.charAt(0).toUpperCase() + weekday.slice(1)}, ${pad2(d.getDate())} de ${month}`;
    };
    const haversineKm = (a, b) => {
      const R = 6371, toRad = (v) => v * Math.PI / 180;
      const dLat = toRad(b.lat - a.lat), dLng = toRad(b.lng - a.lng);
      const lat1 = toRad(a.lat), lat2 = toRad(b.lat);
      const s = Math.sin(dLat/2)**2 + Math.sin(dLng/2)**2 * Math.cos(lat1) * Math.cos(lat2);
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
    };
    const getCountdownToCutoff = (now) => {
      const cutoff = new Date(now); cutoff.setHours(12,0,0,0);
      let target = cutoff;
      if (now.getTime() >= cutoff.getTime()) {
        target = new Date(cutoff); target.setDate(target.getDate() + 1); target.setHours(12,0,0,0);
      }
      const diffMs = Math.max(0, target.getTime() - now.getTime());
      const totalMins = Math.floor(diffMs / 60000);
      return { hrs: Math.floor(totalMins / 60), mins: totalMins % 60 };
    };
    const computeDeliveryWindow = (now, zone) => {
      let minDays = 4, maxDays = 7;
      if (zone === "mty") { minDays = 2; maxDays = 4; }
      const cutoff = new Date(now); cutoff.setHours(12,0,0,0);
      let base = new Date(now); base.setHours(0,0,0,0);
      if (now.getTime() >= cutoff.getTime()) base.setDate(base.getDate() + 1);
      base = nextBusinessDay(base);
      return { start: addBusinessDays(base, minDays), end: addBusinessDays(base, maxDays) };
    };

    const renderLine1 = (cd, delivery) => {
      line1.replaceChildren();
      line1.append('🚨 Realiza tu pedido en ');
      const h = document.createElement('span'); h.className = 'ma-pdp__time-green'; h.textContent = `${cd.hrs} hrs`;
      const m = document.createElement('span'); m.className = 'ma-pdp__time-green'; m.textContent = `${cd.mins} mins`;
      line1.append(h, ' ', m, ' y recíbelo entre ');
      const s1 = document.createElement('strong'); s1.textContent = formatDateEs(delivery.start);
      const s2 = document.createElement('strong'); s2.textContent = formatDateEs(delivery.end);
      line1.append(s1, ' – ', s2);
    };
    const renderPickup = (now) => {
      pickupText.replaceChildren();
      const isBefore4 = now.getHours() < 16;
      if (isBusinessDay(now) && isBefore4) {
        pickupText.textContent = "Recógelo antes de las 5:30 PM";
      } else {
        let next = new Date(now); next.setHours(0,0,0,0); next.setDate(next.getDate() + 1);
        next = nextBusinessDay(next);
        pickupText.append('Recógelo el ');
        const s = document.createElement('strong'); s.textContent = formatDateEs(next);
        pickupText.append(s);
      }
    };

    let zone = "unknown";
    const render = () => {
      const now = new Date();
      const cd = getCountdownToCutoff(now);
      const delivery = computeDeliveryWindow(now, zone);
      renderLine1(cd, delivery);
      renderPickup(now);
    };
    const setZoneFromCoords = (lat, lng) => {
      zone = (haversineKm({lat, lng}, MONTERREY_CENTER) <= MTY_RADIUS_KM) ? "mty" : "mx";
      render();
    };
    const readGeoCache = () => {
      try {
        const raw = localStorage.getItem(GEO_KEY);
        if (!raw) return null;
        const obj = JSON.parse(raw);
        if (!obj || obj.lat == null || obj.lng == null || !obj.ts) return null;
        if ((Date.now() - obj.ts) > GEO_TTL_MS) return null;
        return obj;
      } catch(_) { return null; }
    };
    const writeGeoCache = (lat, lng) => {
      try { localStorage.setItem(GEO_KEY, JSON.stringify({ lat, lng, ts: Date.now() })); } catch(_) {}
    };
    const tryGeoSilentlyIfGranted = async () => {
      if (!navigator.geolocation) return;
      const cached = readGeoCache();
      if (cached) { setZoneFromCoords(cached.lat, cached.lng); return; }
      if (navigator.permissions && navigator.permissions.query) {
        try {
          const perm = await navigator.permissions.query({ name: "geolocation" });
          if (perm.state !== "granted") return;
        } catch(_) { return; }
      } else { return; }
      navigator.geolocation.getCurrentPosition(
        (pos) => { writeGeoCache(pos.coords.latitude, pos.coords.longitude); setZoneFromCoords(pos.coords.latitude, pos.coords.longitude); },
        () => {},
        { enableHighAccuracy: false, timeout: 2500, maximumAge: 600000 }
      );
    };

    render();
    tryGeoSilentlyIfGranted();
    setInterval(render, 10000);
  }());

  // Ingredient spotlight — matches metafield names against snippet DB
  // and renders 1-3 cards using existing .ma-pdp__ingredient styling.
  (function () {
    const section = document.getElementById("maIngredientsSection");
    const grid = document.getElementById("maIngredientsGrid");
    const eyebrow = document.querySelector("[data-ma-ing-eyebrow]");
    const selEl = document.getElementById("maIngredientesSelected");
    const dbEl = document.getElementById("maIngredientesDb");
    if (!section || !grid || !selEl || !dbEl) return;

    let selected = [], db = [];
    try { selected = JSON.parse(selEl.textContent || "[]"); } catch (_) {}
    try { db = JSON.parse(dbEl.textContent || "[]"); } catch (_) {}
    if (!Array.isArray(selected) || selected.length === 0) return;

    const norm = (s) => String(s || "")
      .toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/\s+/g, " ")
      .trim();

    const map = Object.create(null);
    for (let i = 0; i < db.length; i++) map[norm(db[i].name)] = db[i];

    const picked = [];
    for (let j = 0; j < selected.length; j++) {
      const it = map[norm(selected[j])];
      if (it) picked.push(it);
      if (picked.length >= 3) break;
    }
    if (picked.length === 0) return;

    if (eyebrow) eyebrow.textContent = picked.length === 1 ? "Ingrediente principal" : "Ingredientes principales";

    grid.replaceChildren();
    grid.classList.toggle("is-1", picked.length === 1);
    grid.classList.toggle("is-2", picked.length === 2);

    picked.forEach(function (it) {
      const card = document.createElement("article");
      card.className = "ma-pdp__ingredient";

      const media = document.createElement("div");
      media.className = "ma-pdp__ingredient-media";
      const img = document.createElement("img");
      img.src = it.img;
      img.alt = it.name || "";
      img.loading = "lazy";
      media.appendChild(img);

      const h3 = document.createElement("h3");
      h3.textContent = it.name;

      const p = document.createElement("p");
      p.textContent = it.desc;

      card.append(media, h3, p);

      if (it.tag) {
        const tag = document.createElement("span");
        tag.className = "pill leaf";
        tag.textContent = it.tag;
        card.appendChild(tag);
      }

      grid.appendChild(card);
    });

    section.removeAttribute("hidden");
  }());

/* ── Bloque 3: ELIMINADO (2026-07-27) ───────────────────────────────
   Reordenaba el widget de Avada AirReviews en desktop. La tienda pasó a
   Judge.me, que trae su propio layout — el CSS de integración vive en
   assets/component-judgeme.css. */

/* ── Bloque 4 ─────────────────────────────────────────── */
/* Barra de compra fija (solo desktop). Aparece cuando el botón de compra
     real (.ma-pdp__buy-row) queda arriba del viewport. El botón "Agregar"
     dispara el ATC real (mismo AJAX + drawer del custom element). El precio
     se espeja de [data-pdp-price] (que el custom element actualiza al cambiar
     variante) y la cantidad se sincroniza con el input real. */
  (function () {
    if (!window.matchMedia('(min-width: 769px)').matches) return;
    var sticky = document.querySelector('[data-pdp-dsticky]');
    var buyRow = document.querySelector('.ma-pdp__buy-row');
    var form = document.getElementById('ProductForm');
    if (!sticky || !buyRow || !form) return;

    var realQty = form.querySelector('[data-qty-input]');
    var realAtc = form.querySelector('.ma-pdp__atc');
    var realPrice = document.querySelector('.ma-pdp__info [data-pdp-price]');
    var sQty = sticky.querySelector('[data-dsticky-qty-input]');
    var sPrice = sticky.querySelector('[data-pdp-dsticky-price]');
    var sAtc = sticky.querySelector('[data-pdp-dsticky-atc]');

    // Mostrar/ocultar según el botón de compra real
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = e.boundingClientRect.top < 0; // ya lo pasamos hacia abajo
          var show = !e.isIntersecting && past;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(buyRow);
    }

    // Espejar precio (variante) — el custom element reescribe [data-pdp-price]
    if (realPrice && sPrice) {
      var syncPrice = function () { sPrice.textContent = realPrice.textContent; };
      syncPrice();
      new MutationObserver(syncPrice).observe(realPrice, { childList: true, characterData: true, subtree: true });
    }

    // Espejar el botón real (disponible/agotado + total cantidad × precio).
    // OJO: el custom element hace atc.replaceChildren() al recalcular, así que
    // observamos el BOTÓN completo (childList) y releemos el total fresco cada vez.
    var updateAtc = function () {
      if (realAtc.disabled) {
        if (sAtc.firstChild) sAtc.textContent = 'Agotado';
        sAtc.disabled = true;
        return;
      }
      sAtc.disabled = false;
      var st = sAtc.querySelector('[data-pdp-dsticky-total]');
      if (!st) {
        sAtc.innerHTML = 'Agregar al carrito · <span data-pdp-dsticky-total></span>';
        st = sAtc.querySelector('[data-pdp-dsticky-total]');
      }
      var rt = realAtc.querySelector('[data-pdp-line-total]');
      if (rt && st) st.textContent = rt.textContent;
    };
    if (realAtc) {
      updateAtc();
      new MutationObserver(updateAtc).observe(realAtc, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['disabled']
      });
    }

    // Cantidad de la sticky ↔ cantidad real
    function clampQty(v) { v = parseInt(v, 10); return (isNaN(v) || v < 1) ? 1 : v; }
    function pushQty() {
      if (!realQty) return;
      realQty.value = sQty.value;
      realQty.dispatchEvent(new Event('input', { bubbles: true }));
      realQty.dispatchEvent(new Event('change', { bubbles: true }));
    }
    sticky.querySelector('[data-dsticky-qty-dec]').addEventListener('click', function () {
      sQty.value = Math.max(1, clampQty(sQty.value) - 1); pushQty();
    });
    sticky.querySelector('[data-dsticky-qty-inc]').addEventListener('click', function () {
      sQty.value = clampQty(sQty.value) + 1; pushQty();
    });
    sQty.addEventListener('change', function () { sQty.value = clampQty(sQty.value); pushQty(); });
    if (realQty) realQty.addEventListener('change', function () { sQty.value = clampQty(realQty.value); });

    // Agregar desde la sticky → dispara el ATC real (mismo flujo)
    sAtc.addEventListener('click', function () { pushQty(); if (realAtc) realAtc.click(); });
  }());
